<template>
<div>
  <v-overlay v-if="loading" :value="loading">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <!-- <v-container> -->
  <div v-else>
    <v-row>
      <v-col cols="12" sm="1">
        <MyButtons />
      </v-col>
      <v-col cols="12" sm="6" align="right">
        <span class="titr" >گزارشات دوره ای</span>
        <v-btn icon>
          <v-icon v-if="show" @click="show = !show">mdi-eye</v-icon>
          <v-icon v-else @click="show = !show">mdi-eye-off</v-icon>
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="2" align="left">
        <v-select v-model="range" :items="items" item-text="title" item-value="value">
        </v-select>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.buy' title="خرید" dColor="green darken-3" lColor="green lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.sale' title="فروش" dColor="lime darken-3" lColor="lime lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.receipt' title="دریافت" dColor="cyan darken-3" lColor="cyan lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.payment' title="پرداخت" dColor="teal darken-3" lColor="teal lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.cost' title="هزینه" dColor="blue-grey darken-3" lColor="blue-grey lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.income' title="درامد" dColor="orange darken-3" lColor="orange lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.transfer' title="حواله پولی" dColor="deep-orange darken-3" lColor="deep-orange lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
      <v-col cols="12" sm="3">
        <MyTicket :show="show" :data='data.transferSilver' title="حواله نقره" dColor="pink darken-3" lColor="pink lighten-2" mdi="mdi-file-clock-outline" />
      </v-col>
    </v-row>
  </div>
  <!-- </v-container> -->
</div>
</template>

<script>
// @ is an alias to /src
import myAxios from '../../../functions/myAxios'
import MyButtons from '../Buttons.vue'
import MyTicket from './ticket.vue'
// let res = await myAxios({method: 'get', url: `/api/reports?q=${days}`});
export default {
  name: 'MyDashboard',
  watch: {
    range: {
      handler() {
        this.retrieveData()
      }
    },
  },
  methods: {
    async retrieveData() {
      // this.loading = true
      try {
        // console.log(query);
        //
        let res = await myAxios({
          method: 'GET',
          url: `/api/reports?range=${this.range}`,
          // params: query
        });
        if (res && res.data) {
          this.data = res.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.retrieveData()
  },
  components: {
    MyButtons,
    MyTicket
  },
  data: () => ({
    loading: true,
    show: true,
    data: {},
    range: 'today',
    items: [{
      title: 'امروز',
      value: 'today'
    }, {
      title: 'دیروز',
      value: 'yesterday'
    }, {
      title: 'هفته جاری',
      value: 'currentWeek'
    }, {
      title: 'هفته گذشته',
      value: 'weekAgo'
    }, {
      title: 'ماه جاری',
      value: 'currentMonth'
    }, {
      title: 'سال جاری',
      value: 'currentYear'
    }, {
      title: 'سال مالی',
      value: 'fiscal_year'
    }],
  }),
}
</script>

<style lang="scss" scoped>
.titr {
    font-size: 30px;
}
</style>
